module.exports = __webpack_public_path__ + "img/undraw_forgot_password_gi2d.9243d2f7.svg";